import DefectCheckingTitleRow from './DefectCheckingTitleRow';

export default DefectCheckingTitleRow;
